/*
 * @Author: Q in
 * @Date: 2026-03-12 10:58:37
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-25 10:29:23
 * @FilePath: /new_kefu_pc/src/api/index-socket.js
 * @Description: 客户端 socket 接口
 */
//引入axios
import request from '@/utils/index-request';

// 初始化
export function initialize(data) {
	return request({
		url: `/addons/kefu/index/initialize?modulename=${data.modulename}&referrer=${data.referrer}&kefu_tourists_token=${data.kefu_tourists_token}&encryptUserInfo=${data.encryptUserInfo}&source=${data.source}`,
		method: 'get'
	});
}
